// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum AlertStatus {
	Active = 0,
	Acknowledged = 1,
	Resolved = 2,
}

export const AlertStatusDisplayNames: { [key in keyof typeof AlertStatus]?: string} = {
	"Active": "Active",
	0 : "Active",
	"Acknowledged": "Acknowledged",
	1 : "Acknowledged",
	"Resolved": "Resolved",
	2 : "Resolved",
}

export const getAlertStatusDisplayName = (key: AlertStatus | (keyof typeof AlertStatus & string)) => {
	return AlertStatusDisplayNames[key];
}

